import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyQuery } from '@apollo/react-hooks';
import { get, getOr, isEmpty } from 'lodash/fp';
import {
  FontBold, AddStudentButton,
} from '../../Components/Auth/Layout';
import useHeaderComponentsMutation from '../../Hooks/useHeaderComponentsMutation';
import Search from '../../Components/Search/Index';
import { EVENT_TITLE } from '../../Constants/AppConstants';
import { FETCH_EVENT_SCHOOL_STUDENTS } from '../../GraphQL/Queries';
import useCurrentUser from '../../Hooks/userCurrentUser';
import useUserSearch from '../../Hooks/useUserSearch';
import userDefaultImage from '../../Images/icons/userIcon.png';
import useFilterArray from '../../Hooks/useFilterArray';
import UserList from '../../Components/UserList/Index';
import RIGHT_ARROW from '../../Images/icons/right-color-arrow.png';

const TeamStudents = () => {
  const {
    currentUser,
  } = useCurrentUser(true);
  const searchList = useUserSearch();
  const { eventId } = useParams();
  const { schoolId } = useParams();
  const [searchStudents, setSearchStudents] = useState([]);
  const filterArray = useFilterArray();
  const [fetchEventSchoolStudents, { data: studentsData }] = useLazyQuery(
    FETCH_EVENT_SCHOOL_STUDENTS, {
      onCompleted: (data) => {
        setSearchStudents(data.fetchEventSchoolStudents);
      },
    },
  );

  const students = useMemo(() => filterArray((getOr([], 'fetchEventSchoolStudents', studentsData)), 'fetchRole.title', 'Student'), [studentsData, filterArray]);

  useEffect(() => {
    if (currentUser) {
      fetchEventSchoolStudents({
        variables: {
          schoolId: parseInt(schoolId, 10),
          eventId: parseInt(eventId, 10),
        },
      });
    }
  }, [fetchEventSchoolStudents, currentUser, eventId, schoolId]);

  const searchStudent = (e) => {
    if (isEmpty(e.target.value)) {
      setSearchStudents(students);
    } else {
      setSearchStudents(
        searchList(students, e.target.value), // filter from the full list, the current subset
      );
    }
  };

  useHeaderComponentsMutation({
    title: 'STUDENTS',
    backLink: `/event/${eventId}/teams/${schoolId}`,
    components: [{ key: EVENT_TITLE, value: get('[0]fetchEvent.title', students) }],
  });

  return (
    <>
      <div className="mt-4" />
      <div className="container d-none">
        {/* This block will be used in next sprint,thats why this is hidden */}
        <div className="row">
          <AddStudentButton className="col-md-6 col-6">
            <button className="btn text-white text-small" type="button">
              <small className="font-weight-bold">ADD EXISTING USER</small>
            </button>
          </AddStudentButton>
          <AddStudentButton className="col-md-6 col-6">
            <button className="btn text-white text-small" type="button">
              <small className="font-weight-bold">ADD NEW USER</small>
            </button>
          </AddStudentButton>
        </div>
      </div>
      <div className="mt-4" />
      <Search
        placeholder="Search"
        onChange={searchStudent}
      />
      <div className="row">
        <div className="col-12 mx-auto px-4">
          <FontBold>
            <p className="mt-4">
              Students(
              {searchStudents.length}
)
            </p>
          </FontBold>
        </div>
      </div>
      {searchStudents.map((eventUser) => (
        <>
          <div key={eventUser.id}>
            <UserList
              user={get('fetchUser', eventUser)}
              imageAttached={userDefaultImage}
              arrowIcon={RIGHT_ARROW}
              redirectLink={`/event-manage/${eventId}/event-user-profile/${get('id', get('fetchUser', eventUser))}`}
            />
          </div>
        </>
      ))}
    </>
  );
};
export default TeamStudents;
